import React, { useEffect, useState } from "react";
import { authApi, formatApiError, User } from "./api";
import { useAuth } from "./AuthContext";

const ROLE_LABEL: Record<string, string> = { admin: "Admin", consultant: "Konsultan", viewer: "Viewer" };

export default function AdminUsers({ onClose }: { onClose: () => void }) {
  const { user: me } = useAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [nEmail, setNEmail] = useState("");
  const [nName, setNName] = useState("");
  const [nPass, setNPass] = useState("");
  const [nRole, setNRole] = useState("consultant");

  const load = () => authApi.listUsers().then(setUsers).catch((e) => setErr(formatApiError(e?.detail)));
  useEffect(() => { load(); }, []);

  const create = async () => {
    setErr(""); setBusy(true);
    try {
      await authApi.createUser({ email: nEmail.trim(), password: nPass, name: nName.trim() || "Konsultan", role: nRole });
      setNEmail(""); setNName(""); setNPass(""); setNRole("consultant");
      await load();
    } catch (e: any) { setErr(formatApiError(e?.detail)); }
    finally { setBusy(false); }
  };

  const changeRole = async (uid: string, role: string) => {
    setErr("");
    try { await authApi.setRole(uid, role); await load(); }
    catch (e: any) { setErr(formatApiError(e?.detail)); }
  };

  const del = async (uid: string) => {
    if (!window.confirm("Hapus user ini beserta ruang kerjanya?")) return;
    setErr("");
    try { await authApi.deleteUser(uid); await load(); }
    catch (e: any) { setErr(formatApiError(e?.detail)); }
  };

  return (
    <div className="modal-overlay" data-testid="admin-users" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: 640, maxWidth: "94vw" }}>
        <div className="modal-title serif">Kelola pengguna</div>
        <div className="modal-sub">Buat akun konsultan/viewer dan atur peran. Data tiap konsultan bersifat privat (hanya dia dan admin).</div>
        {err && <div className="auth-err" data-testid="admin-error">{err}</div>}

        <div className="admin-create">
          <input placeholder="Email" value={nEmail} onChange={(e) => setNEmail(e.target.value)} data-testid="admin-new-email" />
          <input placeholder="Nama" value={nName} onChange={(e) => setNName(e.target.value)} data-testid="admin-new-name" />
          <input placeholder="Password" type="password" value={nPass} onChange={(e) => setNPass(e.target.value)} data-testid="admin-new-password" />
          <select value={nRole} onChange={(e) => setNRole(e.target.value)} className="pill-sel" data-testid="admin-new-role">
            <option value="consultant">Konsultan</option>
            <option value="viewer">Viewer</option>
            <option value="admin">Admin</option>
          </select>
          <button className="btn on" onClick={create} disabled={busy || !nEmail || !nPass} data-testid="admin-create-user">Tambah</button>
        </div>

        <div className="modal-list" style={{ maxHeight: 360 }}>
          <table className="admin-table" data-testid="admin-user-table">
            <thead><tr><th>Nama</th><th>Email</th><th>Peran</th><th></th></tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} data-testid={`admin-user-${u.id}`}>
                  <td>{u.name}</td>
                  <td className="admin-email">{u.email}</td>
                  <td>
                    <select className="pill-sel" value={u.role}
                      disabled={u.id === me?.id}
                      onChange={(e) => changeRole(u.id, e.target.value)} data-testid={`admin-role-${u.id}`}>
                      {["admin", "consultant", "viewer"].map((r) => <option key={r} value={r}>{ROLE_LABEL[r]}</option>)}
                    </select>
                  </td>
                  <td>
                    {u.id !== me?.id && (
                      <button className="btn danger" style={{ padding: "3px 9px" }} onClick={() => del(u.id)} data-testid={`admin-delete-${u.id}`}>Hapus</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-actions">
          <div style={{ flex: 1 }} />
          <button className="btn on" onClick={onClose} data-testid="admin-close">Tutup</button>
        </div>
      </div>
    </div>
  );
}
